import { tns } from 'tiny-slider'

addEventListener('DOMContentLoaded', _ => {
    document.querySelectorAll('.blog-posts-carousel-wrapper')
        .forEach(wrapper => {
            const carousel = wrapper.querySelector('.blog-posts-carousel')

            const prev = wrapper.querySelector('.prev')
            const next = wrapper.querySelector('.next')

            tns({
                container: carousel,
                items: 1,
                slideBy: 1,
                nav: false,
                arrowKeys: true,
                prevButton: prev,
                nextButton: next,
                autoHeight: true,
            })
        })
})
